export default {
    _prefix: "agentScoringRules.confirmDelete",
    labels: {
        title: "Delete Rule",
        message: "Are you sure you want to delete this rule from the program?",
        confirm: "Yes",
        cancel: "No",
    },
};
